import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getObjectTypesAction } from "../actions/get-object-types.action";
import { ObjectTypesState } from "domain/object-types/entities/interfaces/object-types-state.interface";
import { sortDataByAlphabet } from "app/data/helpers";

const getObjectTypesCases = (
  builder: ActionReducerMapBuilder<ObjectTypesState>
) => {
  builder.addCase(getObjectTypesAction.pending, (state) => {
    state.isLoadingObjectTypes = true;
  });
  builder.addCase(getObjectTypesAction.fulfilled, (state, action) => {
    state.objectTypes = sortDataByAlphabet(action?.payload, "name");
    state.isLoadingObjectTypes = false;
  });
  builder.addCase(getObjectTypesAction.rejected, (state) => {
    state.isLoadingObjectTypes = false;
  });
};

export default getObjectTypesCases;
